import { defineRequest, defineRequestWithParam } from "../axios"
import type {
    CreateUserPayload,
    OperationLogListResponse,
    UpdateUserPayload,
    UpdateUserPermissionsPayload,
    UserItem,
    UserListResponse,
    UserOptionListResponse,
    UserPermissionsResponse,
} from "./types"

// 取得 users
export const getUsers = defineRequest<UserListResponse>({
    url: "/accounts/users/",
    method: "get",
})

// 取得 users 列表
export const getUserOptions = defineRequest<UserOptionListResponse>({
    url: "/accounts/users-options/",
    method: "get",
})

// 取得單個 user
export const getUser = defineRequestWithParam<UserItem>({
    url: (userId: string) => `/accounts/users/${userId}/`,
    method: "get",
})

// 新增 user
export const createUser = defineRequest<void, CreateUserPayload>({
    url: "/accounts/users/",
    method: "post",
})

// 更新 user
export const updateUser = defineRequestWithParam<void, UpdateUserPayload>({
    url: (userId: string) => `/accounts/users/${userId}/`,
    method: "patch",
})

// 啟用 user
export const setUserActive = defineRequestWithParam<void>({
    url: (userId: string) => `/accounts/users/${userId}/activate/`,
    method: "post",
})

// 停用 user
export const setUserInactive = defineRequestWithParam<void>({
    url: (userId: string) => `/accounts/users/${userId}/inactivate/`,
    method: "post",
})

// 刪除 user
export const deleteUser = defineRequestWithParam<void>({
    url: (userId: string) => `/accounts/users/${userId}/`,
    method: "delete",
})

// 取得 user 權限
export const getUserPermissions = defineRequestWithParam<UserPermissionsResponse>({
    url: (userId: string) => `/accounts/users/${userId}/permissions/`,
    method: "get",
})

// 更新 user 權限
export const updateUserPermissions = defineRequestWithParam<void, UpdateUserPermissionsPayload>({
    url: (userId: string) => `/accounts/users/${userId}/permissions/`,
    method: "patch",
})

// 發送 user 啟用信件
export const sendUserEmail = defineRequestWithParam<void>({
    url: (userId: string) => `/accounts/users/${userId}/resend-invite/`,
    method: "post",
})

// 取得操作歷程列表
export const getOperationHistory = defineRequest<OperationLogListResponse>({
    url: "/accounts/users/operation-logs/",
    method: "get",
})
